
import { useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getNakliyeCityIndex, getTopluCityIndexExcel, updateNakliyeCityIndex } from '../../features/nakliyeIndex/nakliyeIndexSlice'
import styled from 'styled-components'
import { BiSolidSortAlt, BiSolidUpArrow, BiSolidDownArrow } from "react-icons/bi";
import InputSelectCityMultiple from '../shared/input/new/InputSelectCityMulti';
import Btn from '../shared/button/Btn';
import SmallSpinner from '../shared/spinners/SmallSpinner';
import { showModal } from '../../features/modal/modalSlice';

const Container = styled.div`
    width: auto;

    .list-filter-container{
        width: 100%;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        gap: 20px;
    }
    .table{
        width: 550px;
        border-collapse: collapse;

        thead{
            width: 100%;
            background-color: var(--color-main);

            tr{

                th{
                    color: #fff;
                    padding: 10px 15px;
                    border-right: 1px solid #fff;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                    text-align: start;
                    width: 200px;

                    &:first-child{
                        border-left: 1px solid var(--color-main);
                    }

                    &:last-child{
                        text-align: center;
                        border-right: 1px solid var(--color-main);
                        width: 150px;
                    }

                    .title-text{
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        .sort-icon{
                            font-size: 1rem;
                            cursor: pointer;
                        }
                    }

                }
            }
        }

        tbody{

            tr{
                td{

                    border: 1px solid ${({theme}) => theme.mainTextColor};
                    text-align: start;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                    padding: 10px 15px;

                    &:last-child{
                        text-align: center;
                    }

                    input{
                        width: 100%;
                        text-align: center;

                    }
                }
            }

        }
    }

    .btn-container{
        width: auto;
        margin: 20px 0;
    }
`


const initialTitles = [
    {
        id: 1,
        text: "İller",
        sortState: 0
    },
    {
        id: 2,
        text: "İndex",
        sortState: 0
    },

]

const NakliyeCityIndex = () => {

    const dispatch = useDispatch()

    //! bu apiden gelen
    const {cityIndexList, isLoadingGetTopluCityIndexExcel} = useSelector(state => state.nakliyeIndex)

    //! bu güncellenmesini sağlayan
    const [updatedDataList, setUpdatedDataList] = useState(cityIndexList)

    //! bu input ile seçilen
    const [selectedCityList, setSelectedCityList] = useState([])

    //! bu filtreleme ile ekrana döndüren
    const [cityListOption, setCityListOption] = useState(updatedDataList)

    const [titles, setTitles] = useState(initialTitles)

    useEffect(() => {
        dispatch(getNakliyeCityIndex())
    },[])

    useEffect(()=> {
        setUpdatedDataList(cityIndexList)
        setCityListOption(cityIndexList)
    },[cityIndexList])

    useEffect(() => {
        const idList = selectedCityList.map(item => item.cityId)
        if(idList.length > 0){
            setCityListOption(updatedDataList.filter(item => idList.includes(item.cityId)))
        }
        else{
            setCityListOption(updatedDataList)
        }

    },[selectedCityList.length])


    const handleChange = ({value, cityId}) => {
        if((value >= 0 && value < 7) || value === ""){
            const list = updatedDataList.map(item => {
                if(item.cityId === cityId) {
                    return {...item, index: value !== "" ? parseInt(value) : ""}
                }
                else{
                    return item
                }
            })
            
            setUpdatedDataList(list)
            setCityListOption(list)
        }
    }

    const handleSortChange = ({id, sortState}) => {

        const titleList = titles.map((item) => {
            if(item.id === id){
                return {...item, sortState}
            }
            else{
                return { ...item, sortState: 0}
            }
        })

        if(id === 1){
            if(sortState === 0){
                setCityListOption([...cityListOption].sort((a, b) => a.city.localeCompare(b.city, 'tr')))
            }
            else if(sortState === 1){
                setCityListOption([...cityListOption].sort((a, b) => b.city.localeCompare(a.city, 'tr')))
            }
            else{
                setCityListOption([...cityListOption].sort((a, b) => a.city.localeCompare(b.city, 'tr')))
            }
        }

        if(id === 2){
            if(sortState === 0){
                setCityListOption([...cityListOption].sort((a, b) => a.index - b.index))
            }
            else if(sortState === 1){
                setCityListOption([...cityListOption].sort((a, b) => b.index - a.index))
            }
            else{
                setCityListOption([...cityListOption].sort((a, b) => a.index - b.index))
            }
        }

        setTitles(titleList)
    }

    const handleSubmit = () => {

        const filtered = updatedDataList.filter((item, i) => {
            const jsonString1 = JSON.stringify(item);
            const jsonString2 = JSON.stringify(cityIndexList[i]);
            return jsonString1 !== jsonString2
        })


        const list = filtered.map((item) => {
            const {cityId, ...others} = item 
            return others
        })

        dispatch(updateNakliyeCityIndex(list))
    }

  return (
    <Container>
        <div className="list-filter-container">
            <InputSelectCityMultiple data={selectedCityList} setData={setSelectedCityList} labelText={"İl Seçiniz"} inputWidth={"290px"} filterKey={"city"} initialOptions={updatedDataList} name={"nakliyeIndexCity"}/>
            <Btn borderColor="#E85446" color="#E85446" width={"200px"} handleClick={() => dispatch(showModal("nakliyeIndexCityAddExcel"))}>Excelden Toplu Kaydet</Btn>
            <Btn borderColor="#E85446" color="#E85446" width={"200px"} handleClick={() => dispatch(getTopluCityIndexExcel())} isDisabled={isLoadingGetTopluCityIndexExcel} cursor={isLoadingGetTopluCityIndexExcel && "not-allowed"}>{isLoadingGetTopluCityIndexExcel ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Excel Çıktı Al"}</Btn>
        </div> 
        <table className="table">
            <thead>
                <tr>
                    {
                        titles.map((item) => (
                            <th key={item.id}>
                                <div className={"title-text"}>
                                    {item.text}
                                    {
                                        item.sortState === 0 &&
                                        <BiSolidSortAlt onClick={() => handleSortChange({id: item.id, sortState: item.sortState === 2 ? 0 : item.sortState+1})} className="sort-icon"/>
                                    }
                                    {
                                        item.sortState === 1 &&
                                        <BiSolidUpArrow onClick={() => handleSortChange({id: item.id, sortState: item.sortState === 2 ? 0 : item.sortState+1})} className="sort-icon"/>
                                    }
                                    {
                                        item.sortState === 2 &&
                                        <BiSolidDownArrow onClick={() => handleSortChange({id: item.id, sortState: item.sortState === 2 ? 0 : item.sortState+1})} className="sort-icon"/>
                                    }
                                </div>
                            </th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
                {
                    cityListOption?.map((item) => (
                        <tr>
                            <td>{item.city}</td>
                            <td>
                                <input type="text" value={item.index} onChange={(e) => handleChange({value: e.target.value, cityId: item.cityId })}/>
                            </td>
                        </tr>
                    ))
                }
             </tbody>
        </table>
        <div className="btn-container">
                <Btn color='#fff' bgColor='#E85446' handleClick={handleSubmit} width={"280px"}>Güncelle</Btn>
        </div>
    </Container>
  )
}

export default NakliyeCityIndex